import React, { useState } from 'react'
import { Link } from 'react-router-dom'

// Ported from the source project's src/components/site/Nav.tsx. Internal routes use
// react-router <Link> (not <a href>) so navigation stays inside the SPA. The two CTAs
// are fixed destinations, not settings-driven: "Log in" -> /login, "Submit a case" ->
// /contant (spelled that way on purpose - the real live route in src/App.js).
const Nav = ({ settings }) => {
    const [open, setOpen] = useState(false);
    const { brandName, brandSub, logoMark, navLinks } = settings;

    return (
        <nav className="site-nav">
            <div className="nav-inner">
                <Link className="nav-logo" to="/" aria-label={brandName}>
                    <div className="logo-mark">{logoMark}</div>
                    <div className="logo-text">
                        {brandName}
                        <span>{brandSub}</span>
                    </div>
                </Link>

                <ul className="nav-links">
                    {navLinks.map((l) => (
                        <li key={l.to}>
                            <Link to={l.to}>{l.label}</Link>
                        </li>
                    ))}
                </ul>

                <div className="nav-cta">
                    <Link className="btn-ghost" to="/login">Log in</Link>
                    <Link className="btn-primary" to="/contant">Submit a case</Link>
                </div>

                <button
                    className="nav-burger"
                    aria-label="Open menu"
                    aria-expanded={open}
                    onClick={() => setOpen(true)}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <line x1="3" y1="6" x2="21" y2="6" />
                        <line x1="3" y1="12" x2="21" y2="12" />
                        <line x1="3" y1="18" x2="21" y2="18" />
                    </svg>
                </button>
            </div>

            {/* Mobile drawer */}
            <div className={`nav-drawer ${open ? 'open' : ''}`} onClick={() => setOpen(false)}>
                <div className="nav-drawer-panel" onClick={(e) => e.stopPropagation()}>
                    <button className="nav-drawer-close" aria-label="Close menu" onClick={() => setOpen(false)}>
                        ×
                    </button>
                    {navLinks.map((l) => (
                        <Link key={l.to} to={l.to} onClick={() => setOpen(false)}>
                            {l.label}
                        </Link>
                    ))}
                    <div className="nav-drawer-cta">
                        <Link className="btn-ghost" to="/login" onClick={() => setOpen(false)}>Log in</Link>
                        <Link className="btn-primary" to="/contant" onClick={() => setOpen(false)}>Submit a case</Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Nav;
